import React from 'react';
import {SvgIconProps} from "@mui/material"
import {CategoryOutlined, NotesOutlined} from "@mui/icons-material"
import {ProjectType} from "../../api/enum/ProjectType"

function ProjectTypeIcon({type, ...props}: {type: ProjectType} & SvgIconProps) {
    switch (type) {
        case ProjectType.CLASSIFIER:
            return <CategoryOutlined {...props}/>
        case ProjectType.FREE_TEXT:
        default:
            return <NotesOutlined {...props}/>
    }
}

export default ProjectTypeIcon;
